import { render, staticRenderFns } from "./factory_detail_base.vue?vue&type=template&id=4b2a6578&scoped=true"
import script from "./factory_detail_base.vue?vue&type=script&lang=js"
export * from "./factory_detail_base.vue?vue&type=script&lang=js"
import style0 from "./factory_detail_base.vue?vue&type=style&index=0&id=4b2a6578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2a6578",
  null
  
)

export default component.exports